import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagOrdemServicoResponse } from '../../responses/servico/get-tag-ordem-servico.response';
import { CreateTagOrdemServicoResponse } from '../../responses/servico/create-tag-ordem-servico.response';
import { TagRequest } from '../../requests/servico/tag.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class TagOrdemServicoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'TagOrdemServico';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(
    descricao: string = '',
    pagina: number = 0,
    tamanhoPagina: number = 20
  ): Observable<GetTagOrdemServicoResponse> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (descricao) {
      params = params.set('descricao', descricao);
    }

    return this.httpClient
      .get<GetTagOrdemServicoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<CreateTagOrdemServicoResponse> {
    const url = `${this.apiUrl}/idTagOrdemServico/${id}`;
    return this.httpClient
      .get<CreateTagOrdemServicoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public create(request: TagRequest): Observable<CreateTagOrdemServicoResponse> {
    return this.httpClient
      .post<CreateTagOrdemServicoResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(id: number, request: TagRequest): Observable<CreateTagOrdemServicoResponse> {
    const url = `${this.apiUrl}/idTagOrdemServico/${id}`;
    return this.httpClient
      .put<CreateTagOrdemServicoResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteBulk(ids: number[]): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/bulk-delete`;
    return this.httpClient
      .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
